import request, { formatRequest } from "@/utils/request"

/** 订阅引导 / 首页引导数据结构 */
export interface GuideInfo {
  /** 表示已完成 */
  finish_step: number
}

const APISubscribeGuide = {
  /**
   * 保存首页引导
   * @param finish_step 已完成步骤
   * @param order_lookup_method 登录方式
   * @param solutions 退货方案
   * @param shipping_method 运输方式
   */
  saveGuideSetting(params) {
    return formatRequest(
      request.post("/go-api/v1/setting/guideSetting", {
        ...params,
      }),
    )
  },

  /**
   * 获取首页订阅引导数据
   */
  getGuideSetting() {
    return formatRequest<GuideInfo>(
      request.get("/go-api/v1/setting/guideSetting"),
    )
  },
}

export default APISubscribeGuide
